import '../../../../resources/js/bootstrap.js';
import ProductGrid            from "./class/tools/ProductGrid";
import GlobalSearch           from "./class/widgets/GlobalSearch";
import AuthHeader             from "./class/widgets/AuthHeader";
import Footer                 from "./class/widgets/Footer";
import {BRDropdown}           from "@dbetts/brjstools";

window.addEventListener('load', function() {

    new ProductGrid();
    new GlobalSearch();
    new AuthHeader();
    new Footer();
    BRDropdown.initAll();
    adjustPipes();
});

window.addEventListener('resize', function() {
    adjustPipes();
});

function adjustPipes() {
    const container = document.getElementById('linksContainer');
    if (container !== null) {
        const children = Array.from(container.children);

        // Initially show all pipes
        children.forEach(child => {
            if ( child.nodeName === 'SPAN' ) {
                child.style.visibility = 'visible';
            }
        });

        // Iterate through children to hide the pipe if it's the first or last in its row
        let previousElement = null;
        children.forEach((child, index) => {
            if ( child.nodeName === 'SPAN' ) {
                const isFirstElementOnLine = previousElement && child.offsetTop > previousElement.offsetTop;
                const isLastElementOnLine = index === children.length - 1 || children[index + 1].offsetTop > child.offsetTop;
                if ( isFirstElementOnLine || isLastElementOnLine ) {
                    child.style.visibility = 'hidden';
                }
            }
            previousElement = child;
        });
    }
}